import { z } from 'zod';

export interface Company {
  id: number;
  cnpj: string;
  company_name: string;
  address: string;
  city: string;
  phone: string;
  email: string;
  created_at: string;
  updated_at: string;
}

export interface CompanyResponse {
  data: Company[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export const companySchema = z.object({
  cnpj: z.string().min(1, 'CNPJ é obrigatório'),
  company_name: z.string().min(1, 'Nome da empresa é obrigatório'),
  address: z.string(),
  city: z.string(),
  phone: z.string(),
  email: z.string().email('Email inválido').optional(),
});
